import axios from "axios";
import { _getBaseUrl } from "./helper";

const restURL = `${_getBaseUrl()}api`;

const api = axios.create({
  baseURL: restURL,
});

api.interceptors.request.use(
  function (config) {
    config.headers["Content-Type"] = "application/json";
    // console.log(`Request, ${config.url}`, config);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    // console.log("Response", response);
    return response;
  },
  (error) => {
    console.log("Error", error.response);
    return Promise.reject(error.response);
  }
);

export default api;
